import React, { useEffect } from "react";
import Events from "../../components/Events/Events";
import Location from "../../components/location/Location"
import LastVideo from "../../components/LastVideo/LastVideo";
import styles from "./Home.module.css";
import { Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Home: React.FC = () => {
  const navigate = useNavigate();
  const [registered, setRegistered] = React.useState(false);


  useEffect(() => {
       const data = localStorage.getItem("usuarioRegistrado");
     
       if (data){
          const usuarioRegistrado = JSON.parse(data);

          if(usuarioRegistrado.email)
             setRegistered(true); 
       }
          
     }, []);
     
  return (
    <div className={styles.homeMain}>
      <LastVideo />
      <hr></hr>
      {!registered ? <> <div>
        <Typography
          variant="h2"
          component="h2"
          align="center"
          sx={{
            fontFamily: "Poppins, sans-serif",
            fontSize: 40,
            lineHeight: 1.2,
            fontWeight: 900,
            marginBottom: 3,
            marginTop: 2,
            color: "black",
          }}
        >
          ¿NUEVO AQUÍ?
        </Typography>
        <Typography variant="body1" component="p" sx={{ textAlign: "center" }}>
          SÉ PARTE DE NUESTRA FAMILIA
        </Typography>
      </div>
      <div className={styles.buttoncontainer}>
        <Button
          onClick={() => navigate("/register")}
          variant="contained"
          size="large"
          sx={{
            backgroundColor: "#fec93b",
            color: "black",
            marginTop: 3,
            marginBottom: 2,
            fontFamily: "Poppins, sans-serif",
            fontSize: "20px",
            fontWeight: "bold",
            borderStyle: "solid",
            borderColor: "black",
            borderWidth: "2px",
            borderRadius: "5px",

            ":hover":{
              background:"black",
              color: "#fec93b"
            }
          }}
        >
          Registrarse
        </Button>
      </div>
      <hr></hr> </> : null}
      
      <Events></Events>
      <hr></hr>

      <Location></Location>
      {/*<div className={styles.imageContainer}>
        <img src={estudio} className={styles.image} alt="Estudio" />
        <button className={styles.button + " " + styles.disabled}>
          CIRCULOS DE ESTUDIO
        </button>
      </div>*/}


    </div>
  );
};

export default Home;
